<template>
<footer class="urban-footer">
  <div class="business-contents">
    <ul class="business-list">
      <li class="list-item" v-for="(item, index) in businessItems" :key="index">
        <a :href="item.banUrl" :title="item.banTitle" target="_self" v-if="item.banView === '002'">
          <!--<span class="item-img" :class="item.banTitle">{{item.fileName}}</span>-->
          <img :src="imgUrl + '/' + item.fileName" :alt="item.banTitle">
        </a>
        <a :href="item.banUrl" :title="item.banTitle" target="_blank" v-else>
          <!--<span class="item-img" :class="item.banTitle">{{item.fileName}}</span>-->
          <img :src="imgUrl + '/' + item.fileName" :alt="item.banTitle">
        </a>
        <!--<a :href="item.banUrl" :title="item.banTitle" target="_blank">
        <img :src="imgUrl + '/' + item.fileName" :class="item-img">
        </a>-->
      </li>
    </ul>
    <form name="KB_AUTHMARK_FORM" method="get">
    <input type="hidden" name="page" value="B009111"/>
    <input type="hidden" name="cc" value="b010807:b008491"/>
    <input type="hidden" name="mHValue" value='b60e645164c7a1ad7e2bf1273bc42896'/>
    </form>
  </div>
  <div class="copyright">
    <div class="column-left">
      <span class="txt bold">Copyright© 2014-2021 주식회사 어반에셋매니지먼트. All rights</span>
      <span class="txt">상호 : 주식회사 어반에셋매니지먼트  |  대표이사 : 정성진<br>사업자 등록번호 : 220-88-78959  |  통신판매업 신고번호 : 제2020-2656호<br>주소 : 서울시 강남구 테헤란로 325  |  전화 : 02-6196-7800  |  팩스 : 02-6196-7812<br>개인정보보호 책임자 : 정성진</span>
    </div>
    <div class="column-right">
      <span class="txt">
        본 사이트에 게시된 매물 정보나 의견은 주식회사 어반에셋매니지먼트와 아무런 관련이 없으며 게시물의 내용과 관련하여 발생한 법적 책임은 게시자 또는 이를 열람하는 이용자가 부담해야하며, 당사에서 제공하는 해당 지역의 전문가 정보는 단순정보제공을 목적으로 하며 해당 업체 이익을 목적으로 하지 않음. 개인간 거래는 거래 당사자가 원하지 않는 이상 일체 개입하지 않으며 정보 및 거래에 대한 손익책임은 거래 당사자 본인에게 있습니다.
      </span>
    </div>
    <span class="kb-logo">
      <button type="button" @click="onPopKBAuthMark()">
        <img src="../img/kb-logo.png" alt="KB에스크로">
      </button>
    </span>
  </div>
</footer>
</template>
<script>

import { mapGetters } from 'vuex'

export default {
  name: 'UrbanFooter',
  data () {
    return {
      imgUrl: this.$store.state.common.urlpath
      /* businessItems: [
        {name: '기업은행', enName: 'ibk', link: 'https://www.naver.com'},
        {name: '농협은행', enName: 'nh', link: 'https://www.naver.com'},
        {name: 'SC제일은행', enName: 'sc', link: 'https://www.naver.com'},
        {name: '기업은행', enName: 'ibk', link: 'https://www.naver.com'}
      ] */
    }
  },
  created () {
    this.initFooterBanner()
  },
  methods: {
    onPopKBAuthMark: function () {
      document.KB_AUTHMARK_FORM.action = 'http://escrow1.kbstar.com/quics'
      document.KB_AUTHMARK_FORM.target = 'KB_AUTHMARK'
      document.KB_AUTHMARK_FORM.submit()
      window.open('', 'KB_AUTHMARK', 'height=604, width=648, status=yes, fullscreen=no, toolbar=no, menubar=no, location=no')
    },
    initFooterBanner () {
      this.$store.dispatch('apiBannerViewList', {'bannerType': '002'})
    }
  },
  computed: {
    ...mapGetters({
      businessItems: 'getBannerFootList'
    })
  }
}
</script>
<style lang="scss" scoped>
@import '../css/style.scss';

// footrt
.urban-footer{
    text-align:center;
    .business-contents{
      display:flex;
      justify-content: center;
      align-items: center;
      padding:5px 0;
      border-top:1px solid #c9caca;
    }
    .kb-logo{
      width:70px;
      height:70px;
    }
    .copyright{
      position:relative;
      flex-wrap: wrap;
      display:flex;
      background:#313131;
      justify-content: center;
      align-items: center;
      padding:30px 170px 30px 50px;
      .column-left{
        position:relative;
        width:460px;
        text-align:left;
        &:after{
          position:absolute;
          top:0;
          right:0;
          display:block;
          content:'';
          width:1px;
          height:100%;
          background:#fff;
        }
      }
      .column-right{
        width:calc(100% - 500px);
        text-align:left;
        margin-left:40px;
      }
      .txt{
        display:block;
        color:#fff;
        font-size:13px;
        letter-spacing: -1px;
        &.bold{
          font-weight: bold;
          margin-bottom:10px;
        }
      }
      .kb-logo{
        position:absolute;
        right:50px;
        top:50%;
        margin-top:-35px;
      }
    }
    .business-list{
        display:flex;
        align-items: center;
        justify-content: center;
        padding:10px 0;
        li{
          padding:0 10px;
        }
    }
    .item-img{
      width:90px;
      height:20px;
      text-indent:-9999px;
      font-size:0;
      display:block;
        &.ibk{
            background: url('../img/main/bank-ibk.png') no-repeat center center;
            background-size:100% auto;
        }
        &.nh{
            background: url('../img/main/bank-nh.png') no-repeat center center;
          background-size:100% auto;
        }
        &.sc{
            background: url('../img/main/bank-sc.png') no-repeat center top;
            background-size:100% auto;
        }
    }
    address{
      margin:0;
      font-style: normal;
      padding:0;
    }
}
@media only screen and (max-device-width:580px) {
  .urban-footer  {
    .copyright{
      background-color: black;
      display: flex;
      flex-wrap: wrap;
      .column-left{
        position: relative;
        &:after {
          position: absolute;
          top: 0;
          right: 0;
          display: block;
          content: "";
          width: 0;
          height: 100%;
          background: #000;
        }
      }
      .column-right{
        text-align: left;
        width: 100%;
        margin-left: 0;
        padding-top: 10px;
      }
    }
  }
}

@media only screen and (max-device-width:1020px) {
  .urban-footer  {
    .copyright{
      background-color: black;
      display: flex;
      flex-wrap: wrap;
      .column-left{
        position: relative;
        &:after {
          position: absolute;
          top: 0;
          right: 0;
          display: block;
          content: "";
          width: 1px;
          height: 100%;
          background: #fff;
        }
      }
      .column-right{
        text-align: left;
        width: 100%;
        margin-left: 0;
        padding-top: 10px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/UrbanFooter.vue